
class flowRegister {

    static values = {};

    static setValue(key, value){

        let flow_values = {};
        try{
            if(sessionStorage.getItem('flow-values')){
                flow_values = JSON.parse(sessionStorage.getItem('flow-values'));
            }else{
                flow_values = flowRegister.values;
            }
        }catch(error){
            flow_values = flowRegister.values;
        }

        flow_values[key] = value;

        try {
            sessionStorage.setItem('flow-values', JSON.stringify(flow_values));
        }catch (e) {}
    }

    static getValue(key){
        try {
            if(sessionStorage.getItem('flow-values')){
                let values = JSON.parse(sessionStorage.getItem('flow-values'));
                return values[key];
            }else{
                return flowRegister.values[key];
            }
        }catch (e) {
            return flowRegister.values[key];
        }
    }

    static removeValue(key){
        delete flowRegister.values[key];
        try {
            if(sessionStorage.getItem('flow-values')){
                let values = JSON.parse(sessionStorage.getItem('flow-values'));
                delete values[key];
                sessionStorage.setItem('flow-values', JSON.stringify(values));
            }
        }catch (e) {}
    }

    static remove(){
        try {
            sessionStorage.removeItem('flow-values');
        }catch (e) {}
        flowRegister.values = {};
    }

}

export {flowRegister}


// WEBPACK FOOTER //
// ./src/services/flowRegister.js